import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import HLTextField from "../../../shared/components/Form/HLTextField";
import { hasDirtyFields } from "../../../shared/helpers/hasDirtyFields";
import { ConfigDataContext } from "../../../shared/providers/ConfigDataProvider";
import { SET_CONFIG_DATA } from "../../../shared/reducer";

interface IOCCategoriesDialog {
  id: string;
  handleCloseDialog: () => void;
}

const defaultValues = {
  description: "",
  usualPrice: "",
  title: "",
  synonyms: [],
};

const OCCategoriesDialog = ({ id, handleCloseDialog }: IOCCategoriesDialog) => {
  // Load state and reducer dispatch
  const { state, dispatch } = useContext(ConfigDataContext);
  const categories = state?.data as any[];

  const isUpdatingCategory = categories.some((category) => category.id === id);
  // Cloning because RHF sometimes overwrites state
  const prevCategory = cloneDeep(categories)?.find(
    (category) => category.id === id
  );

  const methods = useForm({
    defaultValues: isUpdatingCategory ? prevCategory : defaultValues,
  });

  const handleSubmit = (formData: any) => {
    const data = !isUpdatingCategory
      ? [
          // Append category, id = title w/o spaces
          ...categories,
          Object.assign(defaultValues, formData, {
            id: formData.title.replaceAll(" ", ""),
          }),
        ]
      : categories?.map((category) =>
          category.id === id
            ? // Spread edits over previous data
              { ...prevCategory, ...formData }
            : category
        );

    const payload = { ...state, data };

    dispatch({ type: SET_CONFIG_DATA, payload });
  };

  return (
    <Dialog open onClose={handleCloseDialog}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <DialogContent>
            <HLTextField
              name="title"
              label="Kategorie"
              margin="normal"
              required
            />
            <HLTextField
              name="description"
              label="Beschreibung"
              multiline
              rows={3}
              margin="normal"
              required
            />
            <HLTextField
              name="usualPrice"
              label="Normaler Preis"
              type="number"
              margin="normal"
              InputProps={{ endAdornment: "€" }}
              required
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Abbrechen
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={!hasDirtyFields(methods)}
            >
              Speichern
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default OCCategoriesDialog;
